import * as yup from 'yup';
import { addDays, isFuture } from 'date-fns';
import TranslationService from 'app/common/services/translation';
import { ChallengeType } from './types';

export const DEFAULT_WATERMARK_NAME = 'Confidential';

export const WATERMARK_NONE = {
  id: null,
  name: TranslationService.get('None'),
};

export const initialValues = {
  challengeType: ChallengeType.NO_ACCESS,
  passCode: '',
  watermarkId: undefined,
  expiresOn: addDays(new Date(), 1),
  securityControls: {
    isEnabled: false,
    isSavingAllowed: false,
    isPrintingAllowed: false,
    isEditingAllowed: false,
    isCopyingAllowed: false,
  },
};

export const passcodeValidator = yup
  .string()
  .trim()
  .min(3, 'Passcode must be at least 3 characters')
  .required('Passcode is required');

export const validationSchema = yup.object().shape({
  challengeType: yup.string().required(),
  expiresOn: yup.date().when('challengeType', {
    is: (challengeType: ChallengeType) =>
      challengeType !== ChallengeType.NO_ACCESS,
    then: yup
      .date()
      .test('expiresOn', 'expiresOn should be in the future', (value) => {
        return !!value && isFuture(value);
      })
      .required('expiresOn is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  watermarkId: yup.number().nullable(),
  passCode: yup.string().when('challengeType', {
    is: (challengeType: ChallengeType) =>
      challengeType === ChallengeType.PASSCODE,
    then: passcodeValidator,
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const SHARING_HELP_LINK =
  'https://help.ansarada.com/en/articles/6552728-secure-share';
